const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat("sv", {
    style: "decimal",
  })
    .format(amount)
    .replace(/,/g, " ");
};
const RATES = {
  LOW: 7.9,
  MID: 12,
  HIGH: 16,
};

const INTEREST_RATE = 0.0591;

const STARTUP_FEE = 495;

const MONTHLY_FEE = 0;

const calculateIRR = ({
  monthlyTerms,
  value,
  loanAmount,
  irr,
  iterations,
}: {
  monthlyTerms: number;
  value: number;
  loanAmount: number;
  irr: number;
  iterations: number;
}): number => {
  let rate = irr;
  for (let i = 0; i < iterations; i++) {
    let npv = -loanAmount;
    for (let j = 1; j <= monthlyTerms; j++) {
      npv += value / Math.pow(1 + rate, j);
    }
    const derivative =
      -monthlyTerms * value * Math.pow(1 + rate, -monthlyTerms - 1);
    rate -= npv / derivative;
  }
  return rate;
};

const calculateMonthlyPayment = (loanAmount: number, repaymentTime: number) => {
  const monthlyTerms = repaymentTime * 12;
  const termInterest = RATES.MID / 100 / 12;
  const tenure = Math.round(monthlyTerms);
  const value =
    (loanAmount * termInterest) / (1 - 1 / Math.pow(1 + termInterest, tenure)) +
    Math.round(MONTHLY_FEE);

  const irr = calculateIRR({
    monthlyTerms,
    value,
    loanAmount,
    irr: (RATES.MID / 100) * 2,
    iterations: 4,
  });

  // effective interest
  const eff = Math.pow(irr / 12 + 1, 12) - 1;
  const total = monthlyTerms * value + STARTUP_FEE;
  const cost = total - loanAmount;
  return {
    totalCost: total,
    monthlyPayment: value,
    loanCost: cost,
    effectiveRate: eff,
    loanAmount: loanAmount,
    tenure: tenure,
  };
};

export { formatCurrency, calculateMonthlyPayment };
